import * as yup from 'yup';

export const TaxSlipCategorySchema = yup.object({
  name: yup
    .string()
    .required("Name is required")
    .min(2, "Should be minimum 2 characters")
    .max(50, "Should be maximum 50 characters")
});
